import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import { IconButton } from '@/components/ui/IconButton'
import { PanelLeftOpen } from '@/components/icons'

/** The top header. */
export function TopBar({
  title,
  userMenu,
  onOpenSidebar,
  className,
}: {
  title: ReactNode
  userMenu: ReactNode
  /** Mobile only — opens the off-canvas sidebar. */
  onOpenSidebar?: () => void
  className?: string
}) {
  return (
    <header
      className={cn(
        'flex h-14 shrink-0 items-center gap-3 border-b border-line bg-surface px-4 md:px-6',
        className,
      )}
    >
      {onOpenSidebar && (
        <IconButton
          icon={PanelLeftOpen}
          label="Open menu"
          size="sm"
          className="md:hidden"
          onClick={onOpenSidebar}
        />
      )}

      <h1 className="flex-1 truncate text-h2 font-semibold text-text">{title}</h1>

      {userMenu}
    </header>
  )
}
